// Package imports.
import Bugsnag from '@bugsnag/js';

export const bugsnagNotify = (e: Error) => {
    if (process.env.REACT_APP_NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'staging') {
        Bugsnag.notify(e);
    }
}

export async function fetchResponseToDetailedString(title: string, response: Response) {
    let errorBodyString: any = '<no body>';
    let errorBody = null;
    try {
        errorBody = await response.json();
        errorBodyString = JSON.stringify(errorBody);
    } catch {
        errorBody = '<no body>';
    }
    return {
        errorBody,
        errorString: `
            *${title}*;
            body: ${errorBodyString};
            bodyUsed: ${response.bodyUsed};
            headers: ${Array.from(response.headers.entries())};
            ok: ${response.ok};
            redirected: ${response.redirected};
            status: ${response.status};
            statusText: ${response.statusText};
            type: ${response.type};
            url: ${response.url};
        `
    };
}